import React, { Component } from 'react';
import { connect } from 'react-redux';

import PopulationLegend from '../Shared/PopulationLegend';
import DistrictsLegend from '../Shared/DistrictsLegend';
import GameTile from '../Shared/GameTile';

import { addSquare, addSquarePreview, removeSquarePreview } from '../../actions';

const mapStateToProps = state => {
  return {
    num_squares: state.slides.activeSlide.game_info.num_squares,
    squares: state.slides.activeSlide.game_info.squares,
    yourDistricts: state.slides.activeSlide.game_info.yourDistricts
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onSquareClick: square => {
      dispatch(addSquare(square))
    },
    onSquareMouseEnter: square => {
      dispatch(addSquarePreview(square))
    },
    onSquareMouseLeave: id => {
      dispatch(removeSquarePreview(id))
    }
  }
}

class Challenge extends Component {
  constructor(props){
    super(props);
  }
  render() {
    let squares;

    squares = this.props.squares.map((square, i) => {
      return <GameTile key={i} challenge={ this.props.challenge } { ...square }
        handleClick={ this.props.onSquareClick }
        handleMouseEnter={ this.props.onSquareMouseEnter }
        handleMouseLeave={ this.props.onSquareMouseLeave }
      />
    });

    return (
      <div className="gm-slide__challenge">
        <h4 className="gm-slide__subtitle"> { this.props.subtitle } </h4>
        <p className="gm-slide__description"> { this.props.description } </p>
        <div className="gm-slide__info-wrapper">
          <PopulationLegend a={ this.props.population[0] } b={ this.props.population[1] }/>
          <DistrictsLegend { ...this.props.yourDistricts } num_squares={ this.props.num_squares }/>
        </div>

        <div className="gm-slide__game-area">
          { squares }
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Challenge);



// WEBPACK FOOTER //
// ./src/components/Slides/Challenge.js